import _ from "lodash";
import { StyleTypeContext, TranslationContext } from "../..//umbilical_tools";
import PropTypes from "prop-types";
import React, { useCallback, useContext, useEffect, useState } from "react";
import { createUseStyles } from "react-jss";
import { Formik, Form } from "formik";
import "react-datepicker/dist/react-datepicker.css";
import "react-datepicker/dist/react-datepicker-cssmodules.css";
import DatePicker from "react-datepicker";
import { DateTime } from "luxon";
import { useHistory } from "react-router-dom";
import { InlineIcon } from "@iconify/react";
import { useDispatch } from "react-redux";
import { startSearch } from "../../actions/single_search/accommodation_search";
import { Button } from "../common/Button";
import jssVariables from "../../jss_setup";
import { modalGenericStyles } from "../../jss_setup/modals";
import { useApoAuth } from "../../hooks";
import { accSearchFormUpdate } from "../../actions/search/accommodation_search";
import { NoScrollContext } from "../../context";
import {
  RoomSetupController,
  RoomsNumberController,
} from "../MainSearchForm/modals/PaxPickerModalACC";

const searchFormStyles = createUseStyles({
  searchForm: (props) => ({
    position: "relative",
    display: "grid",
    padding: jssVariables.normal_gap,
    background: "white",
    zIndex: 1,
    boxShadow: jssVariables.shadows.normalShadow,
    minWidth: "20vw",
    width: "90vw",
    ..._.get(props, "customStyles.searchForm", {}),
  }),
  actions: (props) => ({
    display: "grid",
    gridGap: jssVariables.normal_gap,
    gridTemplateColumns: "repeat(2, 1fr)",
    marginTop: jssVariables.normal_gap,
    paddingTop: jssVariables.normal_gap,
    borderTop: `2px solid ${jssVariables.colors.base_color}`,
    ..._.get(props, "customStyles.actions", {}),
  }),
  form: (props) => ({
    display: "grid",
    gridGap: props.isInDeepHotel
      ? jssVariables.half_gap
      : jssVariables.normal_gap,
    padding: props.isInDeepHotel ? 0 : jssVariables.normal_gap,
    ..._.get(props, "customStyles.form", {}),
  }),
  inputGroup: (props) => ({
    display: "grid",
    gridGap: `calc(${jssVariables.normal_gap} / 2)`,
    ..._.get(props, "customStyles.inputGroup", {}),
  }),
  label: (props) => ({
    fontSize: "large",
    fontWeight: "bold",
    ..._.get(props, "customStyles.label", {}),
  }),
  paxContainer: (props) => ({
    display: "grid",
    gridGap: `calc(${jssVariables.normal_gap} / 2)`,
    gridTemplateColumns: "max-content 1fr max-content",
    justifyItems: "center",
    alignItems: "center",
    fontSize: "large",
    border: `2px solid ${jssVariables.colors.base_color}`,
    padding: [`calc(${jssVariables.normal_gap} / 2)`, jssVariables.normal_gap],
    color: jssVariables.colors.base_color,
    ..._.get(props, "customStyles.paxContainer", {}),
  }),
  paxBtn: (props) => ({
    borderRadius: "50%",
    height: "2.5rem",
    width: "2.5rem",
    fontSize: "larger",
    display: "inline-grid",
    placeItems: "center",
    padding: 0,
    background: "none",
    border: `2px solid ${jssVariables.colors.base_color}`,
    ..._.get(props, "customStyles.paxBtn", {}),
  }),
  agesContainer: {
    display: "grid",
    gridGap: `calc(${jssVariables.normal_gap} / 2)`,
    gridTemplateColumns: "repeat(2, 1fr)",
  },
  select: (props) => ({
    border: `2px solid ${jssVariables.colors.base_color}`,
    borderRadius: "5px",
    padding: jssVariables.normal_gap,
    ..._.get(props, "customStyles.select", {}),
  }),
  datepicker: (props) => ({
    width: "100%",
    cursor: "pointer",
    padding: jssVariables.normal_gap,
    border: `2px solid ${jssVariables.colors.base_color}`,
    borderRadius: "5px",
    fontSize: "large",
    color: jssVariables.colors.text.dark,
    ..._.get(props, "customStyles.datepicker", {}),
  }),
  overlay: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    background: "white",
    zIndex: 1,
    display: "grid",
    placeItems: "center",
  },
  loader: {
    fontSize: "xxx-large",
    color: jssVariables.colors.base_color,
  },
  [`@media ${jssVariables.media.smallscreen}`]: {
    searchForm: (props) => ({
      width: "25rem",
      ..._.get(props, "customStyles.searchForm.smallscreen", {}),
    }),
    form: (props) => ({
      ..._.get(props, "customStyles.form.smallscreen", {}),
    }),
  },
});
export const HotelSearchForm = ({
  destinationId,
  hotelId,
  isInDeepHotel = false,
  onCancel,
}) => {
  const max_rooms_allowed = 3;
  const [loading, setLoading] = useState(false);
  const { t } = useContext(TranslationContext);

  const history = useHistory();
  const { source_entity, market_type } = useApoAuth();

  const dispatch = useDispatch();
  const onFormUpdate = useCallback(
    ({ form }) => {
      dispatch(accSearchFormUpdate({ form }));
    },
    [dispatch]
  );
  const onAccSearch = useCallback(
    async () =>
      dispatch(
        startSearch({ redirect: true, history, source_entity, market_type })
      ),
    [dispatch]
  );

  const { type, brand, cStyler } = useContext(StyleTypeContext);
  const customStyles = cStyler({ type, brand, objName: "hotelSearchForm" });
  const classes = searchFormStyles({ customStyles, isInDeepHotel });

  return (
    <div className={classes.searchForm}>
      {loading && (
        <div className={classes.overlay}>
          <InlineIcon icon="eos-icons:loading" className={classes.loader} />
        </div>
      )}
      <Formik
        initialValues={{
          checkIn: DateTime.now().plus({ days: 1 }).toISODate(),
          checkOut: DateTime.now().plus({ days: 7 }).toISODate(),
          rooms: [{ adults: 2, children: 0, children_ages: [] }],
        }}
        onSubmit={async (values) => {
          setLoading(true);
          await onFormUpdate({
            form: {
              acc_search_type: "dest",
              destination_meta: {
                uid: destinationId ? destinationId : hotelId,
                location_type: destinationId ? "destination" : "hotel",
              },
              destination_code: destinationId ? [destinationId] : [],
              checkIn: values.checkIn,
              checkOut: values.checkOut,
              rooms: values.rooms,
            },
          });
          await onAccSearch();
          setLoading(false);
        }}>
        {({ values, setFieldValue }) => (
          <Form className={classes.form}>
            <div className={classes.inputGroup}>
              <span className={classes.label}>Check In/Out</span>
              <DatePicker
                className={classes.datepicker}
                dateFormat="MMMM d, yyyy"
                placeholderText="When are you travelling"
                selectsRange
                minDate={DateTime.now().toJSDate()}
                maxDate={DateTime.now().plus({ days: 365 })}
                startDate={
                  values.checkIn
                    ? DateTime.fromISO(values.checkIn).toJSDate()
                    : null
                }
                endDate={
                  values.checkOut
                    ? DateTime.fromISO(values.checkOut).toJSDate()
                    : null
                }
                onChange={(update) => {
                  const [start, end] = update;
                  const checkIn = DateTime.fromJSDate(start).toISODate();
                  const checkOut = DateTime.fromJSDate(end).toISODate();

                  setFieldValue("checkIn", checkIn);
                  setFieldValue("checkOut", checkOut);
                }}
                onFocus={(e) => e.target.blur()}
                withPortal={true}
              />
            </div>
            {max_rooms_allowed > 1 && (
              <RoomsNumberController
                max_rooms_allowed={max_rooms_allowed}
                roomTemplate={{ adults: 2, children: 0, children_ages: [] }}
                rooms={values.rooms}
                onRemove={() =>
                  setFieldValue("rooms", _.cloneDeep(values.rooms).slice(0, -1))
                }
                onAdd={(room) =>
                  setFieldValue("rooms", [..._.cloneDeep(values.rooms), room])
                }
              />
            )}
            <RoomSetupController
              rooms={values?.rooms ?? []}
              setFieldValue={setFieldValue}
              extraCustomStyles={{
                groups: {
                  maxHeight: "30vh",
                  overflow: "auto",
                  smallscreen: {
                    maxHeight: "50vh",
                    gridTemplateColumns: "1fr",
                  },
                },
              }}
            />
            <div className={classes.actions}>
              <Button
                text={t("cancel")}
                revert={true}
                bold={true}
                onClick={(e) => {
                  e.preventDefault();
                  onCancel();
                }}
                customStyles={{ ...(customStyles?.btn ?? {}) }}
              />
              <Button
                text={t("search")}
                type="submit"
                bold={true}
                customStyles={customStyles?.btn ?? {}}
              />
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};
HotelSearchForm.propTypes = {
  isInDeepHotel: PropTypes.bool,
  hotelId: PropTypes.string.isRequired,
  onCancel: PropTypes.func.isRequired,
};

const styles = createUseStyles({
  ...modalGenericStyles,
  HotelSearchFormModal: (props) => ({
    position: "fixed",
    width: "100vw",
    height: "100vh",
    top: 0,
    left: 0,
    display: "grid",
    placeContent: "center",
    zIndex: 9999,
    ...modalGenericStyles.modal,
    ..._.get(props, "customStyles.HotelSearchFormModal", {}),
  }),
  [`@media ${jssVariables.media.smallscreen}`]: {
    HotelSearchFormModal: (props) => ({
      ..._.get(props, "customStyles.HotelSearchFormModal.smallscreen", {}),
    }),
  },
});
const HotelSearchFormModal = ({ destinationId, hotelId, onCancel }) => {
  const { type, brand, cStyler } = useContext(StyleTypeContext);
  const { toggleNoScroll } = useContext(NoScrollContext);

  const classes = styles({
    customStyles: cStyler({
      type,
      brand,
      objName: "HotelSearchFormModal",
    }),
  });

  useEffect(() => {
    toggleNoScroll(true);
    return () => toggleNoScroll(false);
  }, []);

  return (
    <div className={classes.HotelSearchFormModal}>
      <HotelSearchForm
        destinationId={destinationId}
        hotelId={hotelId}
        onCancel={onCancel}
      />
    </div>
  );
};
HotelSearchFormModal.propTypes = {
  destinationId: PropTypes.string,
  hotelId: PropTypes.string,
  onCancel: PropTypes.func.isRequired,
};
export default HotelSearchFormModal;
